import { EChatbotActionTypes } from '../../actions/chatbot';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const chatbotReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EChatbotActionTypes.SetChatbotRowVersion: {
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          rowVersion: action.payload,
        },
      };
    }

    case EChatbotActionTypes.SetChatbotUnreadMessagesCount:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          unreadMessagesCount: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotPollingIntervalId:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          pollingIntervalId: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotPeriodicity:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          periodicity: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotHasPollAnswers:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          hasPollAnswers: action.payload,
        },
      };

    case EChatbotActionTypes.ToggleChatbotPeriodicityMenu:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          isPeriodicityMenuOpened:
            action.payload !== undefined ? action.payload : !state.chatbot.isPeriodicityMenuOpened,
        },
      };

    case EChatbotActionTypes.SetChatbotMessageInfoBlock:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          messageInfoBlock: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotMenuText:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          menuText: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotActionButtons:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          actionButtons: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotOnboardingButtons:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          onboardingButtons: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotMenuActionButtons:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          menuActionButtons: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotIsTyping:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          isTyping: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotMessageSending:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          messageSending: action.payload,
        },
      };
    case EChatbotActionTypes.SetChatbotIsOpenEventSent:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          isOpenEventSent: action.payload,
        },
      };

    case EChatbotActionTypes.SetChatbotMenu:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          chatbotMenu: action.payload,
        },
      };

    default:
      return state;
  }
};
